/**
 * Replaces `previousParentId` with `nextParentId` in `parentIds`.
 * If `previousParentId` is not found, `nextParentId` is appended.
 * Duplicates introduced by the replacement are removed, keeping the first occurrence.
 */
const reassignParentId = ({
  parentIds,
  previousParentId,
  nextParentId,
}: {
  parentIds: Array<string>;
  previousParentId: string;
  nextParentId: string;
}): Array<string> => {
  const nextParentIds = [...parentIds];
  const parentIndex = nextParentIds.findIndex(id => id === previousParentId);

  if (parentIndex >= 0) {
    nextParentIds.splice(parentIndex, 1, nextParentId);
  } else {
    nextParentIds.push(nextParentId);
  }

  return nextParentIds.filter(
    (parentId, index) => nextParentIds.indexOf(parentId) === index,
  );
};

export default reassignParentId;
